<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="设备" prop="deviceId">
        <el-input v-model="dataForm.deviceId" placeholder="设备ID" disabled></el-input>
      </el-form-item>
      <span style="color: #ccc;height: 30px;display: inherit;">通用参数
        <hr style="vertical-align: middle;width: calc(100% - 71px);display: inline-block;">
      </span>
      <el-form-item label="因子编码" prop="code">
        <el-input v-model="dataForm.code" placeholder="因子编码"></el-input>
      </el-form-item>
      <el-form-item label="通道名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="通道名称"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input v-model="dataForm.unit" placeholder="单位"></el-input>
      </el-form-item>
      <el-form-item label="因子类型" prop="type">
        <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报警模式" prop="firstAlarmValue">
        <el-select v-model="dataForm.alarmType" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in alarmTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级预警" prop="firstAlarmValue">
        <el-input v-model="dataForm.firstAlarmValue" placeholder="一级预警"></el-input>
      </el-form-item>
      <el-form-item label="二级预警" prop="secondAlarmValue">
        <el-input v-model="dataForm.secondAlarmValue" placeholder="二级预警"></el-input>
      </el-form-item>
      <el-tooltip class="item" effect="dark" content="请填写设备实际监测通道因子的顺序，否则数据会错乱！设备最多监测15个通道因子。如果是计算值（设备非监测值），请从16-25选择写入"
                  placement="top">
        <el-form-item label="监测顺序" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
        </el-form-item>
      </el-tooltip>
      <span style="color: #ccc;height: 30px;display: inherit;">Modbus参数
        <hr style="vertical-align: middle;width: calc(100% - 90px);display: inline-block;">
      </span>
      <el-form-item label="读取周期" prop="readJob">
            <el-input v-model.number="dataForm.readJob" placeholder="读取周期(秒)" style="width: calc(100% - 50px);float: left;"></el-input>
            <i style="position: absolute;font-size: 20px;font-style: normal;text-align: center;">秒</i>
      </el-form-item>
      <el-form-item label="数据格式" prop="dataFormat">
        <el-select v-model="dataForm.dataFormat" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in typedataFormat"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="字节顺序" prop="byteOrder">
        <el-select v-model="dataForm.byteOrder" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in typebyteOrder"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="指令码" prop="orderCode">
        <el-input v-model="dataForm.orderCode" placeholder="指令码"></el-input>
        <el-button type="primary" @click="btn_crc(dataForm.orderCode)" style="position: absolute;right: 0;">生成CRC</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>
<style>
 .v-modal {
   display: none !important;
 }
</style>
<script>
export default {
  data() {
    return {
      showCron: false,
      visible: false,
      typeOption: [{
        label: '检测值',
        value: 0,
      }, {
        label: '计算值',
        value: 1,
      }],
      typedataFormat: [{
        label: '16位整数',
        value: 'sixTeenFormat',
      }, {
        label: '32位浮点数',
        value: 'thirtyTwoFormat',
      }, {
        label: '32位整数',
        value: 'thirtyTwoInteger',
      }],
      typebyteOrder: [{
        label: 'ABCD',
        value: 'ABCD',
      }, {
        label: 'CDAB',
        value: 'CDAB',
      }, {
        label: 'BADC',
        value: 'BADC',
      }, {
        label: 'DCBA',
        value: 'DCBA',
      }],
      alarmTypeOption: [{
        label: '高报模式',
        value: 0,
      }, {
        label: '低报模式',
        value: 1,
      }, {
        label: '区间报警模式',
        value: 2,
      }],
      dataForm: {
        id: 0,
        deviceId: '',
        code: '',
        name: '',
        unit: '',
        firstAlarmValue: '',
        secondAlarmValue: '',
        note: '',
        status: '',
        sort: '',
        recordValue: '',
        type: '',
        orderCode:'',
        dataFormat:'',
        byteOrder:'',
        readJob:''
      },
      dataRule: {
        code: [
          {required: true, message: '因子编码不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '通道名称不能为空', trigger: 'blur'}
        ],
        unit: [
          {required: true, message: '单位不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '因子类型不能为空', trigger: 'blur'}
        ],
        firstAlarmValue: [
          {required: true, message: '第一预警值不能为空', trigger: 'blur'}
        ],
        secondAlarmValue: [
          {required: true, message: '第二预警值不能为空', trigger: 'blur'}
        ],
        sort: [
          {required: true, message: '监测顺序不能为空', trigger: 'blur'}
        ],
        readJob: [
          {required: true, message: '读取周期不能为空', trigger: 'blur'},
          { type: 'number', message: '读取周期必须为数字值'}
        ],
        dataFormat: [
          {required: true, message: '数据格式不能为空', trigger: 'blur'}
        ],
        byteOrder: [
          {required: true, message: '字节顺序不能为空', trigger: 'blur'}
        ],
        orderCode: [
          {required: true, message: '指令码不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    clickDropdown(command) {
      this.dataForm.name = this.dataForm.name + command;
    },
    clickDropdownunit(command) {
      this.dataForm.unit = this.dataForm.unit + command;
    },
    init(id) {
      this.dataForm = {}
      //根据传来id的值，区分新增、修改
      if (!id.deviceId) {
        this.dataForm.id = id
        //获取id设备的信息
        this.$nextTick(() => {
          this.$http({
            url: this.$http.adornUrl("/task/list"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        })
      } else {//新增
        //情况form表单里的值
        this.dataForm.deviceId = id.deviceId
      }
      this.visible = true
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/task/${!this.dataForm.id ? 'add' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'deviceId': this.dataForm.deviceId,
              'code': this.dataForm.code,
              'name': this.dataForm.name,
              'unit': this.dataForm.unit,
              'firstAlarmValue': this.dataForm.firstAlarmValue,
              'secondAlarmValue': this.dataForm.secondAlarmValue,
              'note': this.dataForm.note,
              'sort': this.dataForm.sort,
              'recordValue': this.dataForm.recordValue,
              'type': this.dataForm.type,
              'dataFormat': this.dataForm.dataFormat,
              'byteOrder': this.dataForm.byteOrder,
              'alarmType': this.dataForm.alarmType,
              'orderCode': this.dataForm.orderCode,
              'readJob': this.dataForm.readJob,
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    btn_crc(data){
      let zhuanhuan = this.MODBUS_CRC(this.Str2Bytes(data))
      let yyy = this.dataForm.orderCode +=  zhuanhuan[0]+zhuanhuan[1]
      this.dataForm.orderCode = yyy.replace(/\s/g,'').replace(/(.{2})/g,"$1 ")
      console.log(this.dataForm.orderCode )
    },
    Str2Bytes(str){
      var pos = 0;
      var len = str.length;
      if(len %2 != 0)
      {
        return null;
      }
      len /= 2;
      var hexA = new Array();
      for(var i=0; i<len; i++)
      {
        var s = str.substr(pos, 2);
        var v = parseInt(s, 16);
        hexA.push(v);
        pos += 2;
      }
      return hexA;
    },
    MODBUS_CRC(data) {
      let crcValue = 0xFFFF;
      for(let i=0;i<data.length;i++){
        crcValue^=data[i]&0xFFFF
        for(let j=0;j<8;j++){
          if(crcValue&0x0001){
            crcValue>>=1
            crcValue^=0xA001
          }else{
            crcValue>>=1
          }
        }
      }
      crcValue=crcValue.toString(16).toUpperCase()
      let crcArr=new Array(2)
      crcArr[0]=crcValue.substring(2,4)
      crcArr[1]=crcValue.substring(0,2)
      return crcArr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/deviceChannelModbus-or-update.vue